import React from 'react';
import UswfButton from '../atoms/buttons/UswfButton';

const IrqChoiceButtons = ({content, onChoiceMade, value, values}) => {
  
  const isKeyAChoice = key => (
    key === 'firstChoice'
    || key === 'secondChoice'
    || key === 'thirdChoice'
    || key === 'fourthChoice'
    || key === 'fifthChoice'
    || key === 'sixthChoice'
    || key === 'seventhChoice'
    || key === 'eighthChoice'
  );
  
  const sortChoices = (choice1, choice2) => {
    if(choice1 === 'firstChoice') return -1;
    if(choice2 === 'firstChoice') return 1;
    if(choice1 === 'secondChoice') return -1;
    if(choice2 === 'secondChoice') return 1;
    if(choice1 === 'thirdChoice') return -1;
    if(choice2 === 'thirdChoice') return 1;
    if(choice1 === 'fourthChoice') return -1;
    if(choice2 === 'fourthChoice') return 1;
    if(choice1 === 'fifthChoice') return -1;
    if(choice2 === 'fifthChoice') return 1;
    if(choice1 === 'sixthChoice') return -1;
    if(choice2 === 'sixthChoice') return 1;
    //for button title
    return 0;
  }
  
  const getBinaryChoiceForKey = (key) => {
    if(key === 'firstChoice')
      return 'Yes';
    if(key === 'secondChoice')
      return 'No';
    return null;
  }
  
  const binaryChoiceList = ['firstChoice', 'secondChoice'];
  
  let filteredContentList = Object.keys(content)
    .filter(isKeyAChoice);
  
  if(filteredContentList.length === 0) {
    //assume this is a binary choice
    filteredContentList = binaryChoiceList;
  }

  filteredContentList.sort(sortChoices);
  const sortedList = filteredContentList.map((key) =>
      content[key] ? content[key] : getBinaryChoiceForKey(key)
  );
  
  
  return (
    <div className="button-group irq-button-group">
      {sortedList.map((contentItem, index) => (
        <UswfButton
          className={values[index] === value ? 'fully-opaque' : '' }
          key={contentItem + index}
          onClick={() => onChoiceMade(index)}
        >
          <span className="choice-button-label">{contentItem}</span>
        </UswfButton>
      ))}
    </div>
  );
};

export default IrqChoiceButtons;
